import * as React from 'react';

import { ActivityStatus } from '@showbie-socrative/socrative-utils';

import { ActiveIcon } from '~teacher/components/Header/ActivityStatusIcons/ActiveIcon';
import { InactiveIcon } from '~teacher/components/Header/ActivityStatusIcons/InactiveIcon';
import { PauseIcon } from '~teacher/components/Header/ActivityStatusIcons/PauseIcon';

export function SmallActivityStatusIcon({
  status,
  className,
}: {
  status: ActivityStatus;
  className?: string;
}) {
  return (
    <div className={className}>
      {(() => {
        if (status === ActivityStatus.Paused) {
          return <PauseIcon className="text-green-700" />;
        } else if (status === ActivityStatus.Running) {
          return <ActiveIcon className="text-green-700" size="micro" />;
        } else {
          return <InactiveIcon className="text-grey-500" size="micro" />;
        }
      })()}
    </div>
  );
}
